import React from "react";
import { useNavigate } from "react-router-dom";
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const About = () => {
  const navigate = useNavigate();

  const goToQuoteForm = () => {
    sessionStorage.setItem("scrollToQuote", "true");
    navigate("/");
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>About HRZ Landscaping</h1>
        <p>
          A passion for beautiful landscapes, built with care and rooted in quality.
        </p>
      </section>

      {/* About Description + Image */}
      <section className="stone-services" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "30px" }}>
        <div style={{ flex: "1 1 400px" }}>
          <p style={{ fontSize: "1.1em", lineHeight: "1.7" }}>
            HRZ Landscaping is a family-run business proudly serving Marin County and surrounding areas.
            With years of experience in residential and commercial landscaping, we bring a blend of craftsmanship, creativity,
            and professionalism to every project.
            <br /><br />
            Our team specializes in lawn maintenance, stonework, irrigation, planting, and custom outdoor living designs.
            Whether you're dreaming of a peaceful garden path or a complete yard transformation,
            we’re here to make it happen — on time and with heart.
          </p>
        </div>

        <div style={{ flex: "1 1 300px" }}>
          <img
            src="/images/about.jpg"
            alt="About HRZ Landscaping"
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "16px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
            }}
          />
        </div>
      </section>

      {/* CTA Section */}
      <section className="stone-cta">
        <p>
          Ready to start your landscaping project? Let's bring your vision to life.
        </p>
        <button
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Request an Estimate <span className="cta-arrow">→</span>
        </button>
      </section>
      <Footer />
    </div>
  );
};

export default About;
